<template>
    <div class="container">
        <TitleInfo title="大数据报告"
                   :tip="'针对热门业务、焦点行业的法律问题，我们在这里给大家准备好了《大数据报告》、《白皮书》等法律大数据实务研究成果，一方面帮助咱们在办案研究时更快速和深度了解行业与专业，另一方面在线下谈案、拜访客户时，给到客户看得见、摸得着的专业呈现与服务体验。'"
                   v-if="classListInfo.ownTotal"></TitleInfo>

        <div class="items">
            <ProdBookItem :items="classListInfo.results" v-if="!$router.currentRoute.query.keyword"/>
            <ClassSearchResult :items="classListInfo.results" v-if="$router.currentRoute.query.keyword"/>
            <Waiting v-if="!classListInfo.ownTotal&&!loading" tips="没有找到相关大数据报告～"/>

        </div>
        <Page :total="classListInfo.ownTotal"
              v-if="classListInfo.ownTotal"
              :current="filterParams.pageIndex*1"
              :page-size="filterParams.pageSize"
              @on-change="handlePageIndexChanged"/>
    </div>
</template>

<script>
    import api from '@/api/calss-search'
    import ProdBookItem from "../components/ProdBookItem";
    import ClassSearchResult from "../components/ClassSearchResult";
    import Empty from "../../class-search-result/empty"
    import TitleInfo from "../components/TitleInfo";
    import Waiting from "../../service-center/Waiting"

    export default {
        name: "ReportCourse",
        data() {
            return {
                loading: false,
                filterParams: {
                    query: this.$router.currentRoute.query.keyword,
                    pageIndex: this.$router.currentRoute.query.pageIndex||1,
                    pageSize:6,
                    searchNumberType: 1,
                    searchType: 'productManual',
                    secondType: 'bigDataReport'
                },
                classListInfo: {
                    results: [],
                    courseTotal: 0,
                },
                totalCount: 0,
                searchTitle: '',
                pageIndex: 0,
                courses: []
            }
        },
        watch: {
            $route(to, from) {
                this.filterParams.query = this.$router.currentRoute.query.keyword
                this.filterParams.pageIndex = this.$router.currentRoute.query.pageIndex||1
                this.filterParams.pageSize = 6
                this.queryList()
            }
        },
        components: {ProdBookItem, Empty, ClassSearchResult, TitleInfo,Waiting},
        methods: {
            // 查询数据
            async queryList() {
                this.loading = true
                api.classSearchList(this.filterParams).then(res => {
                    this.loading = false
                    this.classListInfo = res
                }).finally(() => {
                    this.loading = false
                })
            },
            handlePageIndexChanged(index) {
                this.filterParams.pageIndex = index;
                this.$router.push(`${this.$router.currentRoute.path}?keyword=${this.$router.currentRoute.query.keyword||''}&pageIndex=${index}`)
            }
        },
        mounted() {
            this.queryList();
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped lang="scss">
    .container {
        width: 942px;
        padding: 40px 0px 40px 0px;
        margin: auto;
        margin-left: 45px;
    }

    .totalCount {
        height: 20px;
        margin-left: 10px;
        font-family: PingFangSC;
        font-size: 14px;
        margin-bottom: 32px;
        color: #4a4a4a;
    }

    .items {
        overflow: hidden;
        margin-bottom: 20px;
    }

    .pagination {
        clear: both;
    }
</style>
